<script>
export default {
  name: 'TreeNode',
  props: {
    node: {
      type: Object
    }
  },
  data () {
    return {
      tree: 0
    }
  },
  created () {
    this.indent = this.$parent.indent
  },
  methods: {
    toogle () {
      const node = this.node
      if (node.childNodes) {
        node.expanded = !node.expanded
      }
    }
  }
}
</script>

<template>
  <div class="tree_node" :class="node.expanded ? 'tree_node__active' : ''">
    <div class="tree_label" @click="toogle" :class="!node.childNodes ? 'tree_leaf' : ''" :style="{'padding-left': indent * (node.level - 1) + 'px'}">
      <i v-if="node.childNodes" class="iconfont iconarrow tree_arrow"></i> 
      <slot :node="node">
        <span>{{node.label}}</span>
      </slot>
    </div>
    <div class="tree_children" v-if="node.childNodes">
      <TreeNode v-for="child in node.childNodes" :key="child.id" :node="child"/>
    </div>
  </div>
</template>

<style lang="stylus">
.tree_label
  line-height 20px
  padding 6px
  margin-bottom 6px
  color $blue-200
  display flex
  align-items center
.tree_leaf
  color #444
.tree_label span
  ellipsis()
.tree_arrow
  margin-right 6px
  font-size 12px
  color $gray-400
  transform rotate(-90deg)
.tree_children
  display none
  transition all 5s linear
  height 0
  overflow hidden
.tree_node__active > .tree_label
  background-color $gray-300
  color #444
  &> .tree_arrow
    transform none
.tree_node__active > .tree_children
  display block
  height auto
</style>
